module.exports = __webpack_public_path__ + "static/media/22_A.6c9a772e.png";